// import React from 'react'
// import Pagination from '@mui/material/Pagination';


// export default function PaginationCom({ controller, count, setController }) {
//     return (
//         <Pagination showFirstButton showLastButton count={Math.ceil(count / controller?.rowsPerPage)} page={controller.page} color="primary" onChange={(event, value) => { setController((pre) => ({ ...pre, page: value })) }} />
//     )
// }

import React from 'react'
import TablePagination from '@mui/material/TablePagination';
import useLanguage from '../../hooks/useLanguage';
// import { createTheme, ThemeProvider } from '@mui/material/styles';
export const Pagination = ({ count, setController, controller }) => {
    const { t, isEngLang } = useLanguage();
    const handleChangePage = (event, newPage) => {
        setController({
            ...controller,
            page: newPage + 1
        });
    };
    const handleChangeRowsPerPage = (event) => {
        setController({
            ...controller,
            rowsPerPage: parseInt(event.target.value),
            page: 0 + 1
        });
    };
    return (
        <TablePagination
            sx={{
                '.MuiTablePagination-toolbar': {
                    color: 'var(--black)',
                    height: '35px',
                    fontSize: '15px',
                    display: "flex",
                    alignItems: "center",
                },
                '.MuiTablePagination-actions .MuiIconButton-root': {
                    color: 'var(--black)',
                    borderRadius: '50%',
                    '&:hover': {
                        background: 'rgba(99, 102, 241, 0.1)',
                    }
                },
                '.MuiSelect-select': {
                    minHeight: '24px',
                    padding: '6px 12px',
                    fontSize: '14px',
                },
                '.MuiSvgIcon-root': {
                    color: 'var(--black) !important',
                },

            }}
            rowsPerPageOptions={[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
            component="div"
            count={count}
            rowsPerPage={controller?.rowsPerPage}
            page={controller?.page - 1}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage={t("filterTitle.labelRowsPerPage")}
        />

    )
}
